import { Box, Typography } from '@mui/material';
import React from 'react';
import { RootineDivider } from '../../../atoms/RootineDivider';
import { AnalyteReport, AnalyteResult } from '../../../types';
import { colors, theme } from '../../../utils/theme';

const ResultBox = ({
  result,
  analyte,
}: {
  result: number;
  analyte: AnalyteReport;
}) => {
  const labelString = (): string => {
    if (result < analyte.optimal_min_value) {
      return 'Low';
    } else if (result > analyte.optimal_max_value) {
      return 'High';
    } else {
      return 'Optimal';
    }
  };

  let label = labelString();

  let color;
  switch (label) {
    case 'Low':
      color = colors.primarys.RED;
      break;
    case 'Optimal':
      color = colors.primarys.GREEN;
      break;
    case 'High':
      color = colors.primarys.RED;
      break;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      sx={{ flex: '0 0 35%' }}
    >
      <Typography variant="mono" fontSize={12}>
        {result.toFixed(2)}
      </Typography>
      <Box
        sx={{
          background: color,
          px: 0.25,
          borderRadius: 0.5,
          color: 'white',
          mt: 0.5,
        }}
      >
        <Typography sx={{ fontWeight: theme.typography.mono }} fontSize={10}>
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export const AnalyteHistory = ({ analyte }: { analyte: AnalyteReport }) => {
  const rows = analyte.result_history;

  const formatDateWithDots = (dateString: string) => {
    return dateString.replace(/-/g, '.');
  };
  return (
    <Box sx={{ my: 4 }}>
      <Typography variant="medium" fontSize={18} sx={{ mb: 0.5 }}>
        Result History
      </Typography>
      <RootineDivider dividerProps={{ sx: { mt: 1, mb: 2 } }} />
      <Box display="flex">
        <Typography variant="light" fontSize={14} sx={{ flex: '0 0 35%' }}>
          Date
        </Typography>
        <Typography variant="light" fontSize={14} sx={{ flex: '0 0 35%' }}>
          Result
        </Typography>
      </Box>

      {rows.map((row: AnalyteResult, index: number) => (
        <Box key={index} display="flex" alignItems="center" sx={{ mt: 2 }}>
          {row.date && (
            <Typography variant="mono" fontSize={12} sx={{ flex: '0 0 35%' }}>
              {formatDateWithDots(row.date.split('T')[0])}
            </Typography>
          )}

          <ResultBox result={row.result} analyte={analyte} />
        </Box>
      ))}
    </Box>
  );
};
